import { Typography } from "@mui/material";
import { useLatestPickData } from "./hooks/useLatestPickData";
export default function MostRecentEntryInDB({ comp }: { comp: string }) {
  const { latestQuarter, latestWeek, latestISODate, picks } =
    useLatestPickData();

  return (
    <>
      {comp === "addweek" ? (
        <Typography variant="h6">
          This quarter is{" "}
          {latestQuarter ? (
            <b>{latestQuarter.quarterName}</b>
          ) : (
            <h4 style={{ color: "red", margin: 10 }}>
              Error querying DB to get Quarter, try refreshing page.
            </h4>
          )}
          . The most recent entry/last week was{" "}
          {latestWeek ? (
            <b>
              {latestWeek.weekName}, {latestWeek.weekDate}
            </b>
          ) : (
            <h4 style={{ color: "red", margin: 10 }}>
              Error querying DB to get Week, try refreshing page.
            </h4>
          )}
          (refresh page after submit)
        </Typography>
      ) : comp === "addquarter" ? (
        <Typography variant="h6">
          The latest quarter entry/last quarter was{" "}
          {latestQuarter ? (
            <b>{latestQuarter.quarterName}</b>
          ) : (
            <h4 style={{ color: "red", margin: 10 }}>
              Error querying DB to get Quarter, try refreshing page.
            </h4>
          )}{" "}
          (refresh page on submit).
        </Typography>
      ) : (
        comp === "addpick" && (
          <Typography variant="h6" style={{ fontSize: 17 }}>
            This quarter is{" "}
            {latestQuarter ? (
              <b>{latestQuarter.quarterName}</b>
            ) : (
              <h4 style={{ color: "red", margin: 10 }}>
                Error querying DB to get Quarter, try refreshing page.
              </h4>
            )}
            . This week/next meeting is{" "}
            {latestWeek ? (
              <b>
                {latestWeek.weekName}, {latestWeek.weekDate}
              </b>
            ) : (
              <h4 style={{ color: "red", margin: 10 }}>
                Error querying DB to get Week, try refreshing page.
              </h4>
            )}
            .
            {picks && (
              <Typography variant="h6" style={{ fontSize: 17 }}>
                Picks set for the week:{" "}
                <b>
                  {picks.map((p: any) =>
                    p.pickType !== "Runner Up Song of the Week"
                      ? `${p.pickType}, `
                      : p.pickType
                  )}
                </b>
              </Typography>
            )}
            <h6>
              (refresh page after you submit). Upon reloading, if this is
              inaccurate, you can edit the DB here:{" "}
              <a
                href="https://console.firebase.google.com/u/4/project/mtc-db-firebase/firestore/databases/-default-/data/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ fontWeight: "bold" }}
              >
                FIRESTORE DB
              </a>
              . (Log in with musictastingclub@gmail.com).
            </h6>
          </Typography>
        )
      )}
    </>
  );
}
